<template>
  <h1 class="mx-auto">กำลังกลับไปที่ CMU i-Health</h1>
</template>

<script>
import axios from "axios";
import liff from "@line/liff";

export default {
  async created() {
    let loader = this.$loading.show();

    let { code, state } = this.$route.query;

    state = JSON.parse(state);

    const callbackUri = `${process.env.VUE_APP_URL}/callback`;
    try {
      const response = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_API_URL}/cmu-account/check?code=${code}&callbackUri=${callbackUri}`,
      });

      const { next } = response.data;

      if (next == "register") {
        const { email, firstname, lastname, organizationName } = response.data;
        loader.hide();

        this.$router.push({
          name: "register",
          query: { email, firstname, lastname, organizationName },
        });
      } else if (next == "login") {
        const { token } = response.data;
        localStorage.setItem("TOKEN", token);

        loader.hide();
        this.$notify({
          type: "success",
          group: "foo",
          title: "เข้าสู่ระบบผู้ใช้สำเร็จ",
          text: "ยินดีต้อนรับ",
        });

        if (state.to) {
          this.$router.push(to);
        }

        if (state.user == "admin") {
          this.$router.push({ name: "admin" });
        } else if (state.user == "user") {
          if (liff.isInClient()) {
            this.updateLineIdToUser();
          }

          this.$router.push({ name: "assessments" });
        }
      }
    } catch (error) {
      this.$notify({
        type: "error",
        group: "foo",
        title: "เข้าสู่ระบบผู้ใช้ไม่สำเร็จ",
        text: "ลองใหม่อีกครั้ง",
      });

      loader.hide();
      this.$router.push({ name: "home" });
    }
  },
  methods: {
    async updateLineIdToUser() {
      const profile = await liff.getProfile();

      const response = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_API_URL}/me/register/line`,
        headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` },
        data: {
          lineId: profile.userId,
        },
      });

      this.$notify({
        type: "success",
        group: "foo",
        title: "เชื่อมต่อบัญชี Line Account สำเร็จ",
        text: "ขอบคุณที่ให้ความร่วมมือ",
      });
    },
  },
};
</script>
